import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Cooperation = () => {
  return (
    <section id="cooperation" className="py-24 bg-zinc-950 relative overflow-hidden">
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1/2 h-full opacity-10 pointer-events-none">
        <svg viewBox="0 0 100 100" className="w-full h-full fill-current text-white">
          <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
            <path d="M 10 0 L 0 0 0 10" fill="none" stroke="currentColor" strokeWidth="0.5"/>
          </pattern>
          <rect width="100" height="100" fill="url(#grid)" />
        </svg>
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-4xl bg-zinc-900 border border-zinc-800 p-8 md:p-16 rounded-sm relative">
          <div className="absolute top-0 right-0 w-16 h-16 bg-orange-500 clip-triangle"></div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-5xl font-black uppercase tracking-tighter text-white mb-6">
              Lass uns <span className="text-orange-500">zusammenarbeiten</span>
            </h2>
            <p className="text-lg text-zinc-300 mb-10 max-w-2xl font-medium">
              Du willst deine Marke im Bau-Bereich sichtbar machen? Ich bringe dein Produkt direkt auf die Baustelle – authentisch, glaubwürdig und genau da, wo es deine Zielgruppe sieht.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="https://www.instagram.com/v.rudt/" 
                target="_blank" 
                rel="noreferrer"
                className="px-8 py-4 bg-orange-500 hover:bg-orange-400 text-zinc-950 font-bold uppercase tracking-wider rounded-sm transition-all flex items-center justify-center gap-3"
              >
                <SafeIcon icon={FiIcons.FiMessageSquare} className="w-5 h-5" />
                DM auf Instagram
              </a>
              <a 
                href="mailto:info@valerirudtmedia.de"
                className="px-8 py-4 bg-zinc-800 hover:bg-zinc-700 text-white font-bold uppercase tracking-wider rounded-sm transition-all flex items-center justify-center gap-3"
              >
                <SafeIcon icon={FiIcons.FiMail} className="w-5 h-5" />
                E-Mail schreiben
              </a>
            </div>
          </motion.div>
        </div>
      </div>
      <style dangerouslySetInnerHTML={{ __html: `
        .clip-triangle { clip-path: polygon(100% 0, 0 0, 100% 100%); }
      `}} />
    </section>
  );
};

export default Cooperation;